import React from 'react'
import { motion } from 'framer-motion'

const LoadingState = ({ 
  loading = false, 
  error = null, 
  children, 
  loadingText = 'Загрузка...', 
  emptyText = 'Нет данных',
  emptyIcon,
  onRetry,
  className = ''
}) => {
  // Состояние загрузки
  if (loading) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <motion.div
          className="text-center"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
        >
          {/* Spinner */}
          <div className="relative mb-4">
            <div className="w-12 h-12 border-4 border-gray-200 dark:border-gray-700 rounded-full animate-spin">
              <div className="absolute top-0 left-0 w-12 h-12 border-4 border-transparent border-t-blue-600 rounded-full animate-spin"></div>
            </div>
          </div>
          
          {/* Loading Text */}
          <motion.p
            className="text-gray-600 dark:text-gray-400 font-medium"
            animate={{
              opacity: [0.5, 1, 0.5]
            }}
            transition={{
              duration: 2,
              repeat: Infinity
            }}
          >
            {loadingText}
          </motion.p>
        </motion.div>
      </div>
    )
  }

  // Состояние ошибки
  if (error) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <motion.div
          className="text-center max-w-md"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {/* Error Icon */}
          <div className="w-16 h-16 mx-auto mb-4 bg-red-100 dark:bg-red-900/20 rounded-full flex items-center justify-center">
            <svg className="w-8 h-8 text-red-600 dark:text-red-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L3.732 16.5c-.77.833.192 2.5 1.732 2.5z" />
            </svg>
          </div>

          {/* Error Message */}
          <h3 className="text-lg font-semibold text-gray-900 dark:text-white mb-2">
            Ошибка загрузки
          </h3>
          
          <p className="text-gray-600 dark:text-gray-400 mb-4">
            {error.userMessage || error.message || 'Произошла неожиданная ошибка'}
          </p>

          {/* Retry Button */}
          {onRetry && (
            <button
              onClick={onRetry}
              className="btn-primary inline-flex items-center"
            >
              <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
              </svg>
              Попробовать снова
            </button>
          )}
        </motion.div>
      </div>
    )
  }

  // Проверяем, есть ли дети и не пустые ли они
  const hasContent = React.Children.count(children) > 0

  // Состояние пустых данных
  if (!hasContent) {
    return (
      <div className={`flex items-center justify-center p-8 ${className}`}>
        <motion.div
          className="text-center"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
        >
          {/* Empty Icon */}
          <div className="w-16 h-16 mx-auto mb-4 text-gray-400 dark:text-gray-600">
            {emptyIcon || (
              <svg className="w-full h-full" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={1} d="M20 13V6a2 2 0 00-2-2H6a2 2 0 00-2 2v7m16 0v5a2 2 0 01-2 2H6a2 2 0 01-2-2v-5m16 0h-2.586a1 1 0 00-.707.293l-2.414 2.414a1 1 0 01-.707.293h-3.172a1 1 0 01-.707-.293l-2.414-2.414A1 1 0 006.586 13H4" />
              </svg>
            )}
          </div>

          {/* Empty Text */}
          <p className="text-gray-500 dark:text-gray-400">
            {emptyText}
          </p>
        </motion.div>
      </div>
    )
  }

  // Нормальное состояние с контентом
  return children
}

export default LoadingState